"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2563],{

/***/ 26930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ isVisible; }
/* harmony export */ });
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85518);

var isVisible = function isVisible(platform) {
  if (platform === "android" && (react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isAndroid */ .Dt || react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isBrowser */ .jU)) return true;
  if (platform === "ios" && (react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isIOS */ .gn || react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isMacOs */ .Q5 && react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isBrowser */ .jU && react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isSafari */ .G6)) return true;
  return false;
};

/***/ }),

/***/ 2936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var SvgComponent = function SvgComponent() {
  var w = 31;
  var h = 31;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "back arrow",
    width: w,
    height: h,
    viewBox: "0 0 31 31",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
      "data-name": "Ellipse 6",
      cx: "15.5",
      cy: "15.5",
      r: "15.5",
      fill: "#f7f7f7"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
      "data-name": "Path 603",
      d: "M13.843 20.428a.5.5 0 0 1-.319-.881L18.38 15.5l-4.857-4.046a.5.5 0 1 1 .638-.766l5.316 4.43a.5.5 0 0 1 0 .765l-5.316 4.43a.5.5 0 0 1-.318.115z"
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);

/***/ }),

/***/ 63087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43832);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50066);
/* harmony import */ var _public_animation_glass_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51037);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








var Lottie = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9260)]).then(__webpack_require__.t.bind(__webpack_require__, 69260, 23));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(69260)];
    }
  }
});
var StyledWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
  displayName: "BlockedPayment__StyledWrapper",
  componentId: "sc-1em0z0g-0"
})(["height:100vh;"]);
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  variant: "h1"
}).withConfig({
  displayName: "BlockedPayment__StyledTitle",
  componentId: "sc-1em0z0g-1"
})(["font-size:50px;margin-top:35px;line-height:0.8;color:#000;"]);
var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "BlockedPayment__StyledText",
  componentId: "sc-1em0z0g-2"
})(["margin-top:10px;line-height:0.92;", "{margin-top:22px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs({
  variant: "contained"
}).withConfig({
  displayName: "BlockedPayment__StyledButton",
  componentId: "sc-1em0z0g-3"
})(["width:158px;height:48px;background-color:#ffb900;color:black;font-size:24px;font-family:\"NarkisBlock\",sans-serif;margin-top:40px;"]);
var StyledLottie = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(Lottie).withConfig({
  displayName: "BlockedPayment__StyledLottie",
  componentId: "sc-1em0z0g-4"
})(["height:50%;"]);

var BlockedPayment = function BlockedPayment() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledLottie, {
      animationData: _public_animation_glass_json__WEBPACK_IMPORTED_MODULE_0__,
      loop: false
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledTitle, {
      children: "\u05D0\u05D5\u05E4\u05E1\u05D9, \u05DE\u05E9\u05D4\u05D5 \u05D4\u05E9\u05EA\u05D1\u05E9 \u05D1\u05D3\u05E8\u05DA"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledText, {
      children: "\u05D0\u05DD \u05D4\u05D1\u05E2\u05D9\u05D4 \u05DE\u05DE\u05E9\u05D9\u05DB\u05D4 \u05D0\u05E4\u05E9\u05E8 \u05DC\u05E4\u05E0\u05D5\u05EA \u05DC\u05E9\u05D9\u05E8\u05D5\u05EA \u05DC\u05E7\u05D5\u05D7\u05D5\u05EA."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledButton, {
      onClick: function onClick() {
        return window.open("https://api.whatsapp.com/send?phone=972545738031");
      },
      children: "\u05D1\u05D5\u05D0\u05D5 \u05E0\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1"
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BlockedPayment);

/***/ }),

/***/ 69045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43832);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50066);
/* harmony import */ var _public_animation_glass_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51037);
/* harmony import */ var components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92208);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);










var Lottie = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9260)]).then(__webpack_require__.t.bind(__webpack_require__, 69260, 23));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(69260)];
    }
  }
});
var StyledWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
  displayName: "FailedPage__StyledWrapper",
  componentId: "sc-n46uyf-0"
})(["height:100vh;"]);
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
  variant: "h1"
}).withConfig({
  displayName: "FailedPage__StyledTitle",
  componentId: "sc-n46uyf-1"
})(["font-size:50px;margin-top:35px;line-height:0.8;color:#000;"]);
var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "FailedPage__StyledText",
  componentId: "sc-n46uyf-2"
})(["margin-top:10px;line-height:0.92;", "{margin-top:22px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FailedPage__StyledButtonContainer",
  componentId: "sc-n46uyf-3"
})(["display:flex;justify-content:center;"]);
var StyledGenericButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
  displayName: "FailedPage__StyledGenericButton",
  componentId: "sc-n46uyf-4"
})(["margin-top:40px;"]);
var StyledLottie = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(Lottie).withConfig({
  displayName: "FailedPage__StyledLottie",
  componentId: "sc-n46uyf-5"
})(["height:50%;"]);

var FailPayment = function FailPayment(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "אופסי, משהו השתבש בדר" : _ref$title,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? "אם הבעיה ממשיכה אפשר לפנות לשירות לקוחות." : _ref$text,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? "/" : _ref$link,
      setPaymentSteps = _ref.setPaymentSteps,
      setIframeLink = _ref.setIframeLink,
      retry = _ref.retry,
      setRefList = _ref.setRefList;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var Section1Ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setRefList && setRefList([Section1Ref]);
  }, []);

  var handleRetry = function handleRetry() {
    if (retry) {
      retry();
    } else if (link) {
      if (link === "/payment" || link === "/groupPurchases/payment") {
        setPaymentSteps(1);
        setIframeLink(null);
      } else {
        router.push(link);
      }
    } else {
      router.back();
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledWrapper, {
    ref: Section1Ref,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledLottie, {
      animationData: _public_animation_glass_json__WEBPACK_IMPORTED_MODULE_2__,
      loop: false
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledTitle, {
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledText, {
      children: text
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledButtonContainer, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledGenericButton, {
        onClick: handleRetry,
        btnType: "filled",
        mobileWidth: 238,
        children: "\u05D1\u05D5\u05D0\u05D5 \u05E0\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1"
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FailPayment);

/***/ }),

/***/ 66258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(50029);
/* harmony import */ var _material_ui_core_Container__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(50253);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(22318);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91315);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1438);
/* harmony import */ var components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28218);
/* harmony import */ var components_PurchasePage_PurchaseContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33574);
/* harmony import */ var components_Reusable_Bit_NextLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16110);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(50066);
/* harmony import */ var _public_animation_Conffeti_json__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5081);
/* harmony import */ var _public_animation_Purchase_successful_json__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79412);
/* harmony import */ var common_utils_isVisible__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26930);
/* harmony import */ var components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92208);
/* harmony import */ var components_Icons_PaymentWhatsappIcon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(66473);
/* harmony import */ var components_Icons_TelegramIcon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(57310);
/* harmony import */ var components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(64416);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(85893);


























var Lottie = next_dynamic__WEBPACK_IMPORTED_MODULE_15___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9260)]).then(__webpack_require__.t.bind(__webpack_require__, 69260, 23));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(69260)];
    }
  }
});
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SuccessPayment__StyledWrapper",
  componentId: "sc-jtk1vi-0"
})(["background-size:cover;background-repeat:no-repeat;display:flex;justify-content:center;align-items:center;position:", ";", "{width:", ";height:", ";svg{transform:", ";}}", "{height:", ";margin-top:80px;top:", ";}"], function (p) {
  return p.$conffeti ? "absolute" : "initial";
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return !p.$conffeti && (p.$isGroupPurchase ? "405px" : "450px");
}, function (p) {
  return p.$conffeti ? "auto" : "275px";
}, function (p) {
  return p.$conffeti ? " scale(1) !important;" : "scale(1.5) !important;";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.$isGroupPurchase ? "250px" : "300px";
}, function (p) {
  return p.$conffeti && 0;
});
var StyledName = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z).attrs({
  variant: "h4"
}).withConfig({
  displayName: "SuccessPayment__StyledName",
  componentId: "sc-jtk1vi-1"
})(["margin-top:", ";font-size:40px;text-align:right;font-family:Speedee,NarkisBlock;line-height:normal;", "{text-align:center;}"], function (p) {
  return p.$margin ? "30px" : "0px";
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z).attrs({
  variant: "h1"
}).withConfig({
  displayName: "SuccessPayment__StyledTitle",
  componentId: "sc-jtk1vi-2"
})(["color:", ";font-size:40px;", "{font-size:40px;line-height:0.8;margin-bottom:5px;}"], function (p) {
  return p.theme.colors.black;
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "SuccessPayment__StyledText",
  componentId: "sc-jtk1vi-3"
})(["", "{font-size:24px;line-height:0.92;", "}", "{width:275px;}"], function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$isGroupPurchase) && "margin-top: 20px;";
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledLinksWrapper = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SuccessPayment__StyledLinksWrapper",
  componentId: "sc-jtk1vi-4"
})(["display:flex;gap:24px;align-items:center;margin-top:30px;margin-top:", ";", "{margin-top:", ";}", "{flex-direction:column;}"], function (p) {
  return p.$isGroupPurchase ? "44px" : "20px";
}, function (p) {
  return p.theme.breakpoints.up("sm");
}, function (p) {
  return p.$isGroupPurchase ? "40px" : "30px";
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SuccessPayment__StyledButtonWrapper",
  componentId: "sc-jtk1vi-5"
})(["display:flex;justify-content:", ";", "{justify-content:center;flex-direction:column;padding-top:12px;}"], function (p) {
  return (p === null || p === void 0 ? void 0 : p.$pathname) === "/groupPurchases/payment" ? "center" : "flex-start";
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledBoxWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z).withConfig({
  displayName: "SuccessPayment__StyledBoxWrapper",
  componentId: "sc-jtk1vi-6"
})(["display:flex;flex-direction:column;align-items:center;margin-bottom:", ";", "{display:flex;flex-direction:column;align-items:", ";margin-right:", ";margin-bottom:", ";}"], function (p) {
  return p.$isGroupPurchase ? "30px" : "0px";
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.$isGroupPurchase ? "center" : "start";
}, function (p) {
  return p.$isGroupPurchase ? "0px" : "70px";
}, function (p) {
  return p.$isGroupPurchase ? "40px" : "0px";
});
var StyledBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_material_ui_core_Container__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z).withConfig({
  displayName: "SuccessPayment__StyledBox",
  componentId: "sc-jtk1vi-7"
})(["", "{display:flex;flex-direction:", ";flex-grow:1;align-items:center;justify-content:center;margin-top:120px;}"], function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.$isGroupPurchase ? "column" : "row";
});
var StyledIconsWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z).withConfig({
  displayName: "SuccessPayment__StyledIconsWrapper",
  componentId: "sc-jtk1vi-8"
})(["margin-top:", "px;display:flex;flex-direction:column;position:relative;z-index:9;"], function (p) {
  return p !== null && p !== void 0 && p.$isMobile ? "40" : "22";
});
var StyledShareText = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z).attrs({
  variant: "h3"
}).withConfig({
  displayName: "SuccessPayment__StyledShareText",
  componentId: "sc-jtk1vi-9"
})(["font-family:\"NarkisBlock\";font-weight:bold;margin-bottom:10px;", "{text-align:right;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledLottie = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(Lottie).withConfig({
  displayName: "SuccessPayment__StyledLottie",
  componentId: "sc-jtk1vi-10"
})(["position:relative;z-index:-1;"]);
var StyledSvgDiv = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SuccessPayment__StyledSvgDiv",
  componentId: "sc-jtk1vi-11"
})(["display:flex;align-items:center;justify-content:start;", "{justify-content:center;}gap:16px;"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledSvgWrapper = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SuccessPayment__StyledSvgWrapper",
  componentId: "sc-jtk1vi-12"
})(["cursor:pointer;display:flex;justify-content:center;align-items:center;svg{cursor:pointer;}"]);
var StyledImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)((next_image__WEBPACK_IMPORTED_MODULE_16___default())).withConfig({
  displayName: "SuccessPayment__StyledImage",
  componentId: "sc-jtk1vi-13"
})(["cursor:pointer;"]);
var StyledGiftcardLottie = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(Lottie).withConfig({
  displayName: "SuccessPayment__StyledGiftcardLottie",
  componentId: "sc-jtk1vi-14"
})([""]);

var SuccessPayment = function SuccessPayment() {
  var _usePurchaseContext = (0,components_PurchasePage_PurchaseContext__WEBPACK_IMPORTED_MODULE_4__/* .usePurchaseContext */ .AX)(),
      purchaseData = _usePurchaseContext.purchaseData,
      blessingMode = _usePurchaseContext.blessingMode,
      orderRecipientGuid = _usePurchaseContext.orderRecipientGuid,
      groupPurchaseGuid = _usePurchaseContext.groupPurchaseGuid;

  var _useGroupPurchasesCon = (0,components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_3__/* .useGroupPurchasesContext */ .ZA)(),
      groupPurchasesData = _useGroupPurchasesCon.groupPurchasesData;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)(),
      pathname = _useRouter.pathname;

  var ref = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(""),
      text = _useState[0],
      setText = _useState[1];

  var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
  var isGroupPurchase = router.pathname.includes("groupPurchases");

  var handleAppleWalletClick = /*#__PURE__*/function () {
    var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var _response$data;

      var response, walletUrl;
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,api__WEBPACK_IMPORTED_MODULE_1__.getPassV1GetOrderApplePassUrl)(orderRecipientGuid);

            case 2:
              response = _context.sent;
              walletUrl = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.body;
              setTimeout(function () {
                window.open(walletUrl, "_blank", "noopener,noreferrer");
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAppleWalletClick() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleGoogleWalletClick = /*#__PURE__*/function () {
    var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
      var _response$data2;

      var response, walletUrl;
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0,api__WEBPACK_IMPORTED_MODULE_1__.getPassV1GetGoogleOrderPassUrl)(orderRecipientGuid);

            case 2:
              response = _context2.sent;
              walletUrl = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.body;
              setTimeout(function () {
                window.open(walletUrl, "_blank", "noopener,noreferrer");
              });

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleGoogleWalletClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    if (document) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    !isGroupPurchase && (0,api__WEBPACK_IMPORTED_MODULE_1__.clearApiToken)(); // Scroll to top of page on page load

    if (window) {
      window.scrollTo(0, 0);
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    var _ref$current;

    ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.setSpeed(0.8);
  }, [ref]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    if (orderRecipientGuid) {
      var getData = /*#__PURE__*/function () {
        var _ref3 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
          var _yield$getOrderGetOrd, data;

          return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return (0,api__WEBPACK_IMPORTED_MODULE_1__.getOrderGetOrderGiftCardSharingText)(orderRecipientGuid, groupPurchaseGuid);

                case 2:
                  _yield$getOrderGetOrd = _context3.sent;
                  data = _yield$getOrderGetOrd.data;
                  setText(data.body);

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function getData() {
          return _ref3.apply(this, arguments);
        };
      }();

      getData();
    }
  }, [orderRecipientGuid]);

  var purchaseDate = function purchaseDate() {
    var weekDays = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"];
    var date = purchaseData !== null && purchaseData !== void 0 && purchaseData.messagesScheduleDate ? purchaseData.messagesScheduleDate : null;
    if (!date) return {
      header: "הגיפטקארד נשלח עכשיו!",
      text: ""
    };

    if (date) {
      var minute = moment__WEBPACK_IMPORTED_MODULE_6___default()(date).format("HH:mm");
      var dateFormat = moment__WEBPACK_IMPORTED_MODULE_6___default()(date).format("DD.MM.YY");
      if (moment__WEBPACK_IMPORTED_MODULE_6___default()().format("L") === moment__WEBPACK_IMPORTED_MODULE_6___default()(date).format("L")) return {
        header: "הגיפטקארד יישלח במועד שביקשת!",
        text: "\u05D4\u05D9\u05D5\u05DD, ".concat(dateFormat, ", \u05D1\u05E9\u05E2\u05D4 ").concat(minute)
      };else if (moment__WEBPACK_IMPORTED_MODULE_6___default()().add(1, "days").format("L") === moment__WEBPACK_IMPORTED_MODULE_6___default()(date).format("L")) return {
        header: "הגיפטקארד יישלח במועד שביקשת!",
        text: "\u05DE\u05D7\u05E8, ".concat(dateFormat, ", \u05D1\u05E9\u05E2\u05D4 ").concat(minute)
      };else return {
        header: "הגיפטקארד יישלח במועד שביקשת!",
        text: "\u05D1\u05D9\u05D5\u05DD ".concat(weekDays[moment__WEBPACK_IMPORTED_MODULE_6___default()(date).day()], ", ").concat(dateFormat, ", \u05D1\u05E9\u05E2\u05D4 ").concat(minute)
      };
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledBox, {
    $isGroupPurchase: isGroupPurchase,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledWrapper, {
      $conffeti: false,
      $isGroupPurchase: isGroupPurchase,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledGiftcardLottie, {
        animationData: _public_animation_Purchase_successful_json__WEBPACK_IMPORTED_MODULE_10__,
        lottieRef: ref,
        loop: true
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledWrapper, {
      $conffeti: true,
      children: [isDesktop && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledLottie, {
        animationData: _public_animation_Conffeti_json__WEBPACK_IMPORTED_MODULE_9__,
        loop: true
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledLottie, {
        animationData: _public_animation_Conffeti_json__WEBPACK_IMPORTED_MODULE_9__,
        loop: true
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledBoxWrapper, {
      $isGroupPurchase: isGroupPurchase,
      children: [!isGroupPurchase ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.Fragment, {
        children: [blessingMode === "full" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledName, {
          $margin: false,
          children: ["\u05D0\u05D9\u05D6\u05D4 \u05DB\u05D9\u05E3! \u05E9\u05D9\u05DE\u05D7\u05EA \u05D0\u05EA ", purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.recipientName]
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledName, {
          $margin: false,
          children: "\u05D0\u05D9\u05D6\u05D4 \u05DB\u05D9\u05E3!"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledTitle, {
          children: purchaseDate().header
        }), !(purchaseData !== null && purchaseData !== void 0 && purchaseData.messagesScheduleDate) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledText, {
          children: "\u05D1\u05E8\u05D2\u05E2\u05D9\u05DD \u05D0\u05DC\u05D5 \u05D0\u05E0\u05D7\u05E0\u05D5 \u05E9\u05D5\u05DC\u05D7\u05D9\u05DD \u05E2\u05D3\u05DB\u05D5\u05DF \u05E2\u05DC \u05E7\u05D1\u05DC\u05EA \u05D4\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05D1\u05D4\u05D5\u05D3\u05E2\u05D4"
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledText, {
          children: purchaseDate().text
        }), isDesktop && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledIconsWrapper, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledShareText, {
            children: "\u05D0\u05E4\u05E9\u05E8 \u05DC\u05E9\u05EA\u05E3 \u05D0\u05EA \u05D4\u05DE\u05EA\u05E0\u05D4 \u05DE\u05DB\u05D0\u05DF"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledSvgDiv, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledSvgWrapper, {
              onClick: function onClick() {
                return window.open(isDesktop ? (0,components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_23__/* .shareSocialNetworkLinks */ .rB)(text).whatsapp.desktop : (0,components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_23__/* .shareSocialNetworkLinks */ .rB)(text).whatsapp.mobile);
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_Icons_PaymentWhatsappIcon__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {})
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledSvgWrapper, {
              onClick: function onClick() {
                return window.open(isDesktop ? (0,components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_23__/* .shareSocialNetworkLinks */ .rB)(text).telegram.desktop : (0,components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_23__/* .shareSocialNetworkLinks */ .rB)(text).telegram.mobile);
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_Icons_TelegramIcon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {})
            })]
          })]
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledName, {
          $margin: true,
          children: "\u05D4\u05E7\u05D1\u05D5\u05E6\u05D4 \u05E0\u05D5\u05E6\u05E8\u05D4 \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4!"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledText, {
          $isGroupPurchase: isGroupPurchase,
          children: !isGroupPurchase ? "כניסה לניהול ההזמנה ניתן להיכנס תמיד לעמוד היתרות שלי" : " כדי לנהל את ההזמנה ניתן להיכנס תמיד לעמוד היתרות שלי "
        })]
      }), !isDesktop && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledIconsWrapper, {
        $isMobile: true,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledShareText, {
          children: "\u05D0\u05E4\u05E9\u05E8 \u05DC\u05E9\u05EA\u05E3 \u05D0\u05EA \u05D4\u05DE\u05EA\u05E0\u05D4 \u05DE\u05DB\u05D0\u05DF"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledSvgDiv, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledSvgWrapper, {
            onClick: function onClick() {
              return window.open(isDesktop ? (0,components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_23__/* .shareSocialNetworkLinks */ .rB)(text).whatsapp.desktop : (0,components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_23__/* .shareSocialNetworkLinks */ .rB)(text).whatsapp.mobile);
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_Icons_PaymentWhatsappIcon__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {})
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledSvgWrapper, {
            onClick: function onClick() {
              return window.open(isDesktop ? (0,components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_23__/* .shareSocialNetworkLinks */ .rB)(text).telegram.desktop : (0,components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_23__/* .shareSocialNetworkLinks */ .rB)(text).telegram.mobile);
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_Icons_TelegramIcon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {})
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledLinksWrapper, {
        $pathname: pathname,
        $isGroupPurchase: isGroupPurchase,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_Reusable_Bit_NextLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          href: isGroupPurchase ? //@ts-ignore
          "/balance/groupPurchase?groupCardID=".concat( //@ts-ignore
          groupPurchasesData.guid || "") : "/",
          style: {
            alignSelf: "stretch"
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledButtonWrapper, {
            $pathname: pathname,
            $isGroupPurchase: isGroupPurchase,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
              btnType: "filled",
              width: 190,
              mobileWidth: 155,
              children: isGroupPurchase ? "ממשיכים" : "לחזרה לעמוד הבית"
            })
          })
        }), !isGroupPurchase && blessingMode !== "full" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.Fragment, {
          children: [(0,common_utils_isVisible__WEBPACK_IMPORTED_MODULE_11__/* .isVisible */ .p)("ios") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledImage, {
            src: "/apple-wallet.svg",
            alt: "apple wallet",
            width: 153,
            height: 46,
            onClick: handleAppleWalletClick
          }), (0,common_utils_isVisible__WEBPACK_IMPORTED_MODULE_11__/* .isVisible */ .p)("android") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledImage, {
            src: "/google-wallet.svg",
            alt: "apple wallet",
            width: 153,
            height: 46,
            onClick: handleGoogleWalletClick
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SuccessPayment);

/***/ }),

/***/ 11966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GK": function() { return /* binding */ getPaymentDataFromLocalStorage; },
/* harmony export */   "Hz": function() { return /* binding */ saveGroupPurchasePaymentDataToLocalStorage; },
/* harmony export */   "ZI": function() { return /* binding */ loadBitCom; },
/* harmony export */   "iB": function() { return /* binding */ savePaymentDataToLocalStorage; },
/* harmony export */   "iw": function() { return /* binding */ bitPay; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PAYMENT_EXPIRATION_TIME = 15 * 60 * 1000; // 15 minutes in milliseconds

var savePaymentDataToLocalStorage = function savePaymentDataToLocalStorage(orderRecipientGuid, data) {
  var expirationTime = new Date().getTime() + PAYMENT_EXPIRATION_TIME;

  var storageData = _objectSpread(_objectSpread({}, data), {}, {
    expirationTime: expirationTime
  });

  localStorage.setItem(orderRecipientGuid, JSON.stringify(storageData));
};
var saveGroupPurchasePaymentDataToLocalStorage = function saveGroupPurchasePaymentDataToLocalStorage(groupPurchaseUserGuid, data) {
  var expirationTime = new Date().getTime() + PAYMENT_EXPIRATION_TIME;

  var storageData = _objectSpread(_objectSpread({}, data), {}, {
    expirationTime: expirationTime
  });

  localStorage.setItem(groupPurchaseUserGuid, JSON.stringify(storageData));
};
var getPaymentDataFromLocalStorage = function getPaymentDataFromLocalStorage(orderRecipientGuid) {
  return JSON.parse(localStorage.getItem(orderRecipientGuid));
};
var loadBitCom = function loadBitCom(_ref) {
  var isDesktop = _ref.isDesktop,
      orderRecipientGuid = _ref.orderRecipientGuid,
      groupPurchaseUserGuid = _ref.groupPurchaseUserGuid,
      paymentInitiationId = _ref.paymentInitiationId,
      isAndroid = _ref.isAndroid,
      isIOS = _ref.isIOS,
      transactionSerialId = _ref.transactionSerialId,
      pay = _ref.pay;

  if (isDesktop) {
    if (window.scriptEl) {
      pay(transactionSerialId, paymentInitiationId);
    } else {
      var scriptEl = document.createElement("script");
      scriptEl.src = "https://public.bankhapoalim.co.il/bitcom/sdk";

      scriptEl.onload = function () {
        pay(transactionSerialId, paymentInitiationId);
      };

      document.head.appendChild(scriptEl);
      window.scriptEl = scriptEl;
    }
  } else {
    var _location;

    var storageData = JSON.parse(localStorage.getItem(orderRecipientGuid || groupPurchaseUserGuid));
    var origin = (_location = location) === null || _location === void 0 ? void 0 : _location.origin;
    var encodedReturnScheme = "%26return_scheme%3D".concat(encodeURIComponent(encodeURIComponent("".concat(origin, "/payment/bit?orderguid=").concat(orderRecipientGuid || groupPurchaseUserGuid, "&paymentinitiaionid=").concat(paymentInitiationId))));

    if (storageData) {
      if (isAndroid) {
        var url = "".concat(storageData.paymentData.applicationSchemeAndroid).concat(encodedReturnScheme);
        location.href = url;
      }

      if (isIOS) {
        var _url = "".concat(storageData.paymentData.applicationSchemeIos).concat(encodedReturnScheme);

        location.href = _url;
      }
    }
  }
};
var bitPay = function bitPay(_ref2) {
  var transactionSerialId = _ref2.transactionSerialId,
      paymentInitiationId = _ref2.paymentInitiationId,
      onApproval = _ref2.onApproval,
      _onCancel = _ref2.onCancel;

  if (window.BitPayment) {
    window.BitPayment.pay({
      transactionSerialId: transactionSerialId,
      paymentInitiationId: paymentInitiationId,
      env: "Prod",
      onApproved: function onApproved() {
        onApproval();
      },
      onCancel: function onCancel() {
        _onCancel();
      },
      onTimeout: function onTimeout() {
        _onCancel();
      }
    });
  }
};

/***/ }),

/***/ 34839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52663);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50066);
/* harmony import */ var _public_animation_loader_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44708);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var Lottie = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9260)]).then(__webpack_require__.t.bind(__webpack_require__, 69260, 23));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(69260)];
    }
  }
});
var StyledDialog = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
  displayName: "LoaderPopup__StyledDialog",
  componentId: "sc-1pjfxy6-0"
})([".MuiBackdrop-root{backdrop-filter:none;background-color:rgba(0,0,0,0.3);}.MuiDialog-paper{box-shadow:none;align-items:center;justify-content:center;width:150px;height:150px;background-color:#fff;border-radius:50%;overflow:visible;}"]);
var StyledLottie = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(Lottie).withConfig({
  displayName: "LoaderPopup__StyledLottie",
  componentId: "sc-1pjfxy6-1"
})(["width:250px;height:250px;"]);

var LoaderPopup = function LoaderPopup(_ref) {
  var isOpen = _ref.isOpen;
  return (
    /*#__PURE__*/
    // mui dialog with no close buttons and only lottie animation.
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledDialog, {
      open: isOpen,
      "aria-label": "\u05D8\u05E2\u05D9\u05E0\u05D4....",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledLottie, {
        animationData: _public_animation_loader_json__WEBPACK_IMPORTED_MODULE_1__
      })
    })
  );
};

/* harmony default export */ __webpack_exports__["Z"] = (LoaderPopup);

/***/ })

}]);